import { render, staticRenderFns } from "./BaseChipClose.vue?vue&type=template&id=ed7592f4&"
import script from "./BaseChipClose.vue?vue&type=script&lang=js&"
export * from "./BaseChipClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports